export enum SessionStatus {
  CONNECTED,
  CONNECTING,
  DISCONNECTED,
  ENDED,
}
